// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["assets/public/css/ehs"], () => (__webpack_require__("./resources/assets/public/themes/ehs/js/theme.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/public/css/ehs"], () => (__webpack_require__("./resources/assets/public/themes/ehs/scss/theme.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
